/**
 * Once Cero — free shipping meter.
 *
 * The server render is correct on load; this keeps it correct after an AJAX
 * add-to-cart by listening to Dawn's cartUpdate event. Falls back silently if
 * the pub/sub globals are absent, since the server-rendered state is still valid.
 */
(function () {
  'use strict';

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function render(el, total) {
    var threshold = parseInt(el.dataset.threshold, 10);
    if (!threshold || isNaN(total)) return;

    var remaining = threshold - total;
    var unlocked = remaining <= 0;
    var pct = Math.min(100, Math.round((total / threshold) * 100));

    el.classList.toggle('oc-ship--unlocked', unlocked);

    var fill = el.querySelector('[data-oc-ship-fill]');
    if (fill) fill.style.width = pct + '%';

    var msg = el.querySelector('[data-oc-ship-msg]');
    if (msg) {
      msg.innerHTML = unlocked
        ? '<span class="oc-ship__flag" aria-hidden="true">★</span> ' +
          (el.dataset.unlocked || 'Free shipping unlocked')
        : '<span class="oc-ship__flag" aria-hidden="true">▸</span> ' +
          money(remaining, el.dataset.currency) + ' ' +
          (el.dataset.away || 'from free shipping');
    }

    var foot = el.querySelector('[data-oc-ship-foot]');
    if (foot) {
      foot.textContent = unlocked
        ? (el.dataset.unlockedFoot || 'Ships free on us.')
        : (el.dataset.foot || 'Free shipping on orders over') + ' ' +
          money(threshold, el.dataset.currency);
    }
  }

  function refresh() {
    var els = document.querySelectorAll('[data-oc-ship]');
    if (!els.length) return;
    fetch(window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        els.forEach(function (el) { render(el, cart.total_price); });
      })
      .catch(function () { /* server-rendered state stands */ });
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
    // Restoring from bfcache can show a stale cart total.
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
